var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitedOfferBannerPinkShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 242,
    viewBox: "0 0 457 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.445435 242C-9.60253 96.5568 152.84 17.4305 235.317 0H445C451.627 0 457 5.37258 457 12V230C457 236.627 451.627 242 445 242H0.445435Z",
    fill: "url(#paint0_linear_8247_182816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8247_182816",
    x1: 52,
    y1: 206.305,
    x2: 256.473,
    y2: -179.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D0036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D70081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0072"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedOfferBannerPinkShape);
export default __webpack_public_path__ + "static/media/limited-offer-banner-pink-shape.2cfb7aa638cdb04c9adf309010a4ac5f.svg";
export { ForwardRef as ReactComponent };